import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class ShareableLinkController extends BridgeComponent {
  static component = "share";
  static targets = ["shareApi", "socialShare"];
  static values = { url: String, text: String };

  // BridgeComponent's default shouldLoad returns false unless the native app's UA
  // advertises this component, which would break the controller on web browsers.
  static get shouldLoad() {
    return true;
  }

  connect() {
    super.connect();
    if (this.isMobile()) {
      this.shareApiTarget.classList.remove("hidden");
    } else {
      this.socialShareTarget.classList.remove("hidden");
    }
  }

  share() {
    // this.enabled is true when the native app's UA includes "share" in bridge-components.
    if (this.enabled) {
      this.send("share", { url: this.urlValue, title: this.textValue }, () => {});
    } else {
      navigator.share({ title: this.textValue, url: this.urlValue });
    }
  }

  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
}
